import {inject, Injectable} from '@angular/core';
import {BaseApiService} from "./base-api.service";

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  private readonly apiService = inject(BaseApiService);

  async getDashboard() {
    return await this.apiService.get(`/dashboard`);
  }
}
